import {observable, runInAction, makeObservable} from 'mobx';
import {decorate, inject, injectable} from '@yosmanyga/di';
import {CredentialManager, LanguageManager} from '@yosmanyga/base';
import {PlayApi} from '../data';

class RestartController {
    restarting: boolean;

    constructor(
        private playApi: PlayApi,
        private languageManager: LanguageManager,
        private credentialManager: CredentialManager
    ) {
        this.restarting = false;
        
        makeObservable(this, {
            restarting: observable,
        });
    }

    restart = async () => {
        runInAction(() => {
            this.restarting = true;
        });

        await this.playApi.restartGame();
        await this.languageManager.delete();
        await this.credentialManager.delete();

        runInAction(() => {
            this.restarting = false;
        });
    };
}

decorate(injectable(), RestartController);
decorate(inject(PlayApi), RestartController, 0);
decorate(inject(LanguageManager), RestartController, 1);
decorate(inject(CredentialManager), RestartController, 2);

export {RestartController};
